import React from "react";
import { usePermissions } from "react-admin";
import { MultiLevelMenu } from "@react-admin/ra-navigation";

import { filterByPermissions } from "../security/utils";
import { resources, settings } from "../../app";

const BuildSubMenu = ({ resource, parentPath }) => {
  const menuStyle = settings.menuStyle && settings.menuStyle();

  const path = settings.useBreadcrumb ? `${parentPath ? `${parentPath}.` : ""}${resource.name}` : resource.name;

  const itemStyle = menuStyle?.MultiLevelMenuItem;
  const subItemStyle = menuStyle?.MultiLevelMenuSubItem;

  return (
    <MultiLevelMenu.Item
      key={resource.name}
      name={resource.name}
      to={resource.subMenu ? null : path}
      label={resource.title}
      icon={resource.icon}
      sx={resource.subMenu ? itemStyle : subItemStyle}
    >
      {resource.subMenu &&
        resource.subMenu
          .filter(subResource => subResource.isMenu)
          .map(subResource => (
            <BuildSubMenu
              key={subResource.name}
              parentPath={path}
              resource={subResource}
            />
          ))}
    </MultiLevelMenu.Item>
  );
};

const Menu = () => {
  const menuStyle = settings.menuStyle ? settings.menuStyle() : null;

  const { permissions } = usePermissions();

  const menuItems = filterByPermissions(resources, permissions).filter(resource => resource.isMenu);

  return (
    <MultiLevelMenu sx={menuStyle?.MultiLevelMenu}>
      {menuItems.map(resource => (
        <BuildSubMenu
          resource={resource}
          key={resource.name}
        />
      ))}
    </MultiLevelMenu>
  );
};

export default Menu;
